export const isJson = (ob) => {
	return (
		ob !== "" &&
		typeof ob === "string" &&
		!new RegExp("^[0-9]{3}|[0-9]{3}$").test(ob) &&
		/^[\],:{}\s]*$/.test(
			ob
				.replace(/\\["\\\/bfnrtu]/g, "@")
				.replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, "]")
				.replace(/(?:^|:|,)(?:\s*\[)+/g, "")
		)
	);
};
